import { useQuery } from "@tanstack/react-query";
import * as AgenticV2API from "@/services/api/agentic-v2";
import { useCompanyId } from "@/context/CompanyContext";
import { useWindowLive } from "@/components/ui/os-layout/WindowActiveContext";
import { clientsKeys } from "./keys";

export interface UseClientDetailOptions {
  faClientId: string;
  enabled?: boolean;
}

/** Fetch the full detail document for one fa_client. */
export function useClientDetail({
  faClientId,
  enabled: enabledOption = true,
}: UseClientDetailOptions) {
  const isWindowLive = useWindowLive();
  const companyId = useCompanyId();
  const queryEnabled = Boolean(faClientId) && enabledOption;

  const query = useQuery({
    queryKey: clientsKeys.detail(faClientId, companyId ?? undefined),
    enabled: queryEnabled,
    refetchOnWindowFocus: queryEnabled && isWindowLive,
    queryFn: () => AgenticV2API.getClient(faClientId),
  });

  return {
    client: query.data ?? null,
    loading: query.isLoading && !query.data,
    error: query.error,
    refresh: () => void query.refetch(),
  };
}
